class ImageCarousel extends HTMLElement {
  constructor() {
    super();
    this.carousel = this.querySelector(".swiper");
    this.carouselNext = this.querySelector("[data-image-carousel-next]");
    this.carouselPrev = this.querySelector("[data-image-carousel-prev]");

    window.loadSwiper.then((swiperLib) => {
      this.swiperLib = swiperLib;
      this.init();
    });
  }

  init() {
    const { Swiper, Pagination, Scrollbar } = this.swiperLib;

    const swiperParams = {
      modules: [Pagination, Scrollbar],
      scrollbar: {
        el: ".swiper-scrollbar",
        draggable: true,
      },
      spaceBetween: 15,
      speed: 200,
      slidesPerView: 1.3,
      slidesPerGroup: 1,
      loop: true,
      grid: {
        rows: 1,
      },
      centerInsufficientSlides: true,
      mousewheel: {
        forceToAxis: true,
      },
      navigation: {
        nextEl: this.carouselNext,
        prevEl: this.carouselPrev,
      },
      breakpoints: {
        992: {
          spaceBetween: 90,
          slidesPerView: 3,
        },
      },
    };

    this.swiper = new Swiper(this.carousel, swiperParams);

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        observer.unobserve(this);
        this.querySelectorAll('img[loading="lazy"]').forEach((img) => {
          img.loading = "eager";
        });
        observer.disconnect();
      }
    });

    observer.observe(this);
  }
}

if (!customElements.get("image-carousel")) {
  customElements.define("image-carousel", ImageCarousel);
}
